/* src/app/modules/expense/bail/bail.component.css */
.example-icon {
  padding: 0 14px;
}
.toolbar-spacer {
  flex: 1 1 auto;
}
.index-row {
  flex: 5;
}
.index-button {
  flex: 1;
}
table thead tr {
  background: #e3fd64;
}
tfoot {
  background-color: #343a40;
  color: white;
}
:host {
  --bl-brand: #e3fd64;
  --bl-brand-d: #4d7a00;
  --bl-text: #1a1d23;
  --bl-muted: #6b7280;
  --bl-border: #e5e7eb;
  --bl-bg: #f4f6f8;
  --bl-surface: #ffffff;
  --bl-radius: 10px;
  --bl-shadow: 0 2px 8px rgba(0,0,0,0.07);
}
.bl-page {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: var(--bl-bg);
  font-family: "Inter Tight", sans-serif;
}
.bl-header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 24px;
  background: var(--bl-surface);
  border-bottom: 1px solid var(--bl-border);
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  flex-wrap: wrap;
}
.bl-header__icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  background: rgba(227, 253, 100, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.bl-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
  color: var(--cf-brand-dark);
}
.bl-header__title {
  margin: 0 0 2px;
  font-size: 1rem;
  font-weight: 700;
  color: var(--bl-text);
  line-height: 1.3;
}
.bl-header__sub {
  margin: 0;
  font-size: 0.78rem;
  color: var(--bl-muted);
}
.bl-header__spacer {
  flex: 1;
}
.bl-saved-icon {
  color: #16a34a !important;
  font-size: 22px;
}
.bl-btn-save {
  background: var(--bl-brand) !important;
  color: rgba(0, 0, 0, 0.85) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}
.bl-body {
  padding: 20px 24px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
}
@media (max-width: 768px) {
  .bl-header {
    padding: 10px 14px;
  }
  .bl-body {
    padding: 12px;
  }
}
.bl-initial-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px;
}
.bl-loading-dots {
  display: flex;
  gap: 8px;
}
.bl-loading-dots span {
  display: block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--bl-brand);
  opacity: 0.3;
  animation: bl-bounce 1.2s ease-in-out infinite;
}
.bl-loading-dots span:nth-child(2) {
  animation-delay: .2s;
}
.bl-loading-dots span:nth-child(3) {
  animation-delay: .4s;
}
@keyframes bl-bounce {
  0%, 80%, 100% {
    opacity: .3;
    transform: scale(.9);
  }
  40% {
    opacity: 1;
    transform: scale(1.2);
  }
}
.bl-spinner-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  border-radius: inherit;
}
.bl-top-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
@media (max-width: 768px) {
  .bl-top-grid {
    grid-template-columns: 1fr;
  }
}
.bl-col {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.bl-section {
  border: 1px solid var(--bl-border);
  border-radius: var(--bl-radius);
  overflow: hidden;
  margin-bottom: 0;
}
.bl-section__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  background: var(--bl-bg);
  border-bottom: 1px solid var(--bl-border);
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--bl-text);
}
.bl-section__head mat-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: var(--bl-brand);
  flex-shrink: 0;
}
.bl-section__body {
  padding: 12px;
  background: var(--bl-surface);
  display: flex;
  flex-direction: column;
  gap: 0;
}
.bl-section__body--no-pad {
  padding: 0;
}
.bl-section__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 10px;
  background: var(--bl-brand);
  color: rgba(0, 0, 0, 0.85);
  font-size: 11px;
  font-weight: 700;
}
.bl-lines-spacer {
  flex: 1;
}
.bl-btn-add {
  font-size: 13px !important;
  line-height: 28px !important;
  height: 28px !important;
  border-radius: 8px !important;
  border-color: var(--bl-brand) !important;
  color: var(--bl-brand-d) !important;
}
.bl-btn-add mat-icon {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  margin-right: 4px;
}
.bl-empty-lines {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px;
  color: var(--bl-muted);
}
.bl-empty-lines mat-icon {
  font-size: 36px;
  width: 36px;
  height: 36px;
  opacity: 0.4;
}
.bl-empty-lines p {
  margin: 0;
  font-size: 13px;
}
.bl-table-wrap {
  overflow-x: auto;
}
.bl-lines-table {
  background: transparent !important;
}
.bl-lines-table .mat-mdc-header-cell {
  background: var(--bl-bg) !important;
  color: var(--bl-text) !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-bottom: 1px solid var(--bl-border) !important;
}
.bl-lines-table .mat-mdc-cell {
  font-size: 13px;
  color: var(--bl-text);
  border-bottom: 1px solid #f0f0f0 !important;
}
.bl-lines-table .mat-mdc-row:last-child .mat-mdc-cell {
  border-bottom: none !important;
}
.bl-lines-table .mat-mdc-row:hover .mat-mdc-cell {
  background: rgba(227, 253, 100, 0.04);
}
.bl-th-right,
.bl-td-right {
  text-align: right !important;
}
.bl-td-total {
  font-weight: 600;
  color: var(--bl-brand-d);
}
.bl-td-actions {
  white-space: nowrap;
  text-align: right;
}
.bl-totals {
  padding: 12px 16px;
  background: var(--bl-bg);
  border-top: 1px solid var(--bl-border);
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
}
.bl-totals__row {
  display: flex;
  align-items: center;
  gap: 24px;
  min-width: 240px;
}
.bl-totals__lbl {
  flex: 1;
  font-size: 13px;
  color: var(--bl-muted);
}
.bl-totals__lbl--bold {
  font-weight: 700;
  color: var(--bl-text);
}
.bl-totals__val {
  font-size: 13px;
  font-weight: 500;
  color: var(--bl-text);
  text-align: right;
}
.bl-totals__val--bold {
  font-size: 15px;
  font-weight: 700;
  color: var(--bl-brand-d);
}
.bl-totals__row--tax {
  justify-content: flex-end;
}
.bl-totals__tax {
  font-size: 12px;
  color: var(--bl-muted);
}
.bl-totals__row--grand {
  border-top: 1px solid var(--bl-border);
  margin-top: 4px;
  padding-top: 6px;
}
::ng-deep .bl-section__body .mat-mdc-form-field-subscript-wrapper {
  min-height: 0 !important;
}
::ng-deep .bl-section__body .mat-mdc-form-field-bottom-align::before {
  display: none !important;
}
/*# sourceMappingURL=bail.component.css.map */
